var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginDialogBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 1194 834",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1194,
    height: 834,
    fill: "#00224A",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1195,
    height: 834,
    fill: "url(#paint0_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m863.31 362c193.63 0 333.69 45.64 333.69 45.64v374.36h-1197v-289.5s130.77-56.063 381.8-84.86c83.228-9.547 257.04-45.64 481.51-45.64z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.86 382c-193.15 0-332.86 49.118-332.86 49.118v402.88h1194v-402.88s-130.45 30.991-380.84 0c-83.019-10.275-256.4-49.118-480.3-49.118z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.31,
    cy: 170.27,
    r: 69.949,
    fill: "#2F9381"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 319.97,
    cy: 141.98,
    r: 69.949,
    fill: "#2F9381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.03 312.93h23.271l4.986 144.61h-33.243l4.986-144.61z",
    fill: "#836F68"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-49.927 294.82 368.05)",
    x: 294.82,
    y: 368.05,
    width: 58.178,
    height: 6.6486,
    fill: "#836F68"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(39.184 252.8 307.81)",
    x: 252.8,
    y: 307.81,
    width: 58.178,
    height: 4.4005,
    fill: "#836F68"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.41,
    cy: 245.61,
    r: 90.588,
    fill: "#2F9381"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243.64,
    cy: 255.58,
    r: 70.642,
    fill: "#2F9381"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m923.13 369.15-10.4-19.663c-0.8-1.508-2.4-2.491-4.133-2.491h-35.867c-2.066 0-3.733 1.639-3.733 3.67v17.5h1.867v-17.5c0-1.048 0.866-1.835 1.866-1.835v8.324l0.934 6.423-0.934 5.506 0.934 12.912h2.333v-11.011l1.067-1.311 0.4 3.212 2.266 9.176h2.334l-1.2-9.242h0.133l-0.867-7.079 11.4 2.425h9.467l-1.8 13.83h2.333l2.934-12.519 1.733 3.277 1 9.242h2.333v-13.83l13.334 13.83h1.933c0.867 0 1.533-0.655 1.533-1.507v-8.849l2.6-2.556-5.8 0.066z",
    fill: "#020203"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m337.98 418.61c-0.256-0.45-0.622-1.038-1.041-1.55-0.787-0.962-2.015-1.872-2.333-1.718-0.386 0.187-0.173 2.138 0.096 3.088 0.152 0.537 0.468 1.467 0.643 1.976-0.743 0.708-1.504 1.63-2.06 2.74-0.802 1.599-1.363 3.838-1.274 5.427 0.091 1.645 0.32 3.178 1.653 4.115 1.185 0.832 2.184 1.02 5.559-1.96 2.815-2.485 7.103-6.636 8.223-9.262l-6.449-4.056c-0.282 0.062-1.636 0.507-3.017 1.2z",
    clipRule: "evenodd",
    fill: "#000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377.72 434.78 0.928-14.374-8.182-1.761-0.567 5.185h0.142l-1.28 11.028h2.489l2.417-10.949 0.427-3.833 1.137 1.565v13.139h2.489z",
    clipRule: "evenodd",
    fill: "#020203",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.41 435.1-1.776-16.451h-8.451v16.451h2.309l0.99-11.027 1.716-3.911 2.903 14.938h2.309zm-10.502-16.158 0.235-0.293h-0.117l-0.118 0.293z",
    clipRule: "evenodd",
    fill: "#020203",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m342.2 405.94c0.01 0.101 0.022 0.202 0.036 0.302-3.041 1.15-5.059 4.23-4.725 7.621 0.338 3.434 2.982 6.086 6.247 6.572 2e-3 0.221 0.013 0.444 0.035 0.668 0.4 4.053 4.01 7.016 8.063 6.616 2.044-0.201 3.81-1.218 5.008-2.697 1.51 1.84 3.881 2.916 6.428 2.665 2.522-0.249 4.621-1.74 5.752-3.808 1.468 1.241 3.418 1.91 5.482 1.706 4.054-0.399 7.016-4.009 6.617-8.062-0.026-0.266-0.066-0.527-0.119-0.782 3.059-1.141 5.092-4.231 4.757-7.634-0.33-3.353-2.858-5.96-6.016-6.534-6e-3 -0.077-0.012-0.154-0.02-0.232-0.399-4.053-4.009-7.016-8.062-6.616-1.998 0.197-3.73 1.173-4.926 2.597-1.493-2.012-3.975-3.213-6.65-2.949-2.648 0.261-4.831 1.892-5.914 4.122-1.456-1.184-3.362-1.817-5.377-1.618-4.053 0.399-7.015 4.009-6.616 8.063z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.34 395.28c0.173-0.304 0.42-0.701 0.703-1.047 0.531-0.649 1.359-1.263 1.574-1.159 0.261 0.126 0.117 1.443-0.064 2.084-0.103 0.363-0.317 0.992-0.435 1.335 0.501 0.478 1.013 1.099 1.388 1.847 0.541 1.079 0.92 2.59 0.86 3.663-0.061 1.11-0.216 2.145-1.116 2.777-0.799 0.562-1.474 0.689-3.752-1.322-1.899-1.678-4.794-4.48-5.55-6.252l4.353-2.737c0.191 0.041 1.106 0.343 2.039 0.811z",
    clipRule: "evenodd",
    fill: "#000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.52 406.2-0.626-9.701 5.522-1.189 0.383 3.5h-0.096l0.864 7.443h-1.68l-1.631-7.39-0.288-2.587-0.768 1.056v8.868h-1.68z",
    clipRule: "evenodd",
    fill: "#020203",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201.91 406.41 1.199-11.104h5.704v11.104h-1.559l-0.668-7.443-1.158-2.639-1.959 10.082h-1.559zm7.08-10.916-0.15-0.188h0.074l0.076 0.188z",
    clipRule: "evenodd",
    fill: "#020203",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m211.49 386.74c-6e-3 0.067-0.014 0.135-0.024 0.202 2.054 0.775 3.418 2.855 3.192 5.144-0.228 2.32-2.014 4.11-4.22 4.437-1e-3 0.149-9e-3 0.298-0.024 0.449-0.269 2.736-2.706 4.735-5.442 4.466-1.379-0.136-2.571-0.823-3.38-1.821-1.019 1.242-2.62 1.969-4.338 1.799-1.702-0.167-3.119-1.174-3.882-2.569-0.992 0.838-2.308 1.289-3.702 1.152-2.736-0.269-4.735-2.706-4.466-5.442 0.018-0.179 0.045-0.356 0.081-0.528-2.064-0.771-3.436-2.856-3.21-5.152 0.223-2.264 1.93-4.023 4.062-4.41 3e-3 -0.053 8e-3 -0.105 0.013-0.158 0.269-2.736 2.706-4.735 5.442-4.466 1.347 0.133 2.516 0.792 3.323 1.752 1.008-1.357 2.683-2.166 4.487-1.989 1.789 0.177 3.262 1.278 3.993 2.784 0.983-0.799 2.269-1.226 3.629-1.092 2.736 0.27 4.736 2.706 4.466 5.442z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m258.12 413.16 0.723-11.499-6.364-1.409-0.442 4.149h0.111l-0.995 8.822h1.935l1.88-8.76 0.332-3.065 0.885 1.251v10.511h1.935z",
    clipRule: "evenodd",
    fill: "#020203",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.52 413.41-1.382-13.161h-6.573v13.161h1.796l0.77-8.822 1.334-3.128 2.258 11.95h1.797zm-8.167-12.929 0.18-0.232h-0.089l-0.091 0.232z",
    clipRule: "evenodd",
    fill: "#020203",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230.27 383c0.162-0.363 0.35-0.831 0.478-1.3 0.26-0.957 0.29-2.179 0.05-2.317-0.291-0.166-1.438 0.87-1.923 1.483-0.27 0.343-0.715 0.968-0.962 1.319-0.778-0.157-1.696-0.228-2.641-0.084-1.376 0.211-3.052 0.873-4.024 1.662-1.006 0.816-1.879 1.672-1.879 2.975 0 1.158 0.212 2.079 3.732 2.738 1.731 0.323 4.145 0.303 6.006 0.288 1.23-0.01 2.218-0.019 2.608 0.076l1.532-5.253c-0.175-0.166-1.576-0.958-2.977-1.587z",
    clipRule: "evenodd",
    fill: "#000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.36 387.34c0 0.081 2e-3 0.162 5e-3 0.243-2.441 0.678-4.236 2.971-4.236 5.696 0 2.761 1.844 5.079 4.334 5.723-0.015 0.176-0.023 0.355-0.023 0.535 0 3.259 2.568 5.9 5.737 5.9 1.597 0 3.043-0.672 4.083-1.756 1.028 1.583 2.782 2.626 4.772 2.626 1.969 0 3.707-1.021 4.74-2.576 1.042 1.101 2.498 1.785 4.11 1.785 3.169 0 5.737-2.642 5.737-5.9 0-0.214-0.011-0.424-0.033-0.632 2.458-0.667 4.27-2.968 4.27-5.705 0-2.697-1.76-4.971-4.162-5.675 1e-3 -0.061 2e-3 -0.123 2e-3 -0.184 0-3.259-2.568-5.9-5.736-5.9-1.559 0-2.973 0.639-4.007 1.677-1.003-1.717-2.832-2.866-4.921-2.866-2.071 0-3.886 1.129-4.894 2.821-1.037-1.058-2.465-1.712-4.041-1.712-3.168 0-5.737 2.641-5.737 5.9z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m272.8 522.45-39.346-75.842c-3.027-5.815-9.08-9.607-15.638-9.607h-135.7c-7.8188 0-14.124 6.32-14.124 14.157v67.5h7.0622v-67.5c0-4.045 3.2789-7.078 7.0622-7.078v32.106l3.5312 24.776-3.5312 21.236 3.5312 49.803h8.8277v-42.472l4.0356-5.056 1.5131 12.388 8.576 35.393h8.828l-4.54-35.646h0.504l-3.279-27.304 43.13 9.354h35.816l-6.81 53.343h8.827l11.098-48.287 6.558 12.641 3.783 35.646h8.828v-53.343l50.445 53.343h7.314c3.279 0 5.801-2.528 5.801-5.815v-34.129l9.837-9.859-21.944 0.252z",
    fill: "#020203"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m920.39 606.38 92.143-176.08c7.09-13.499 21.26-22.303 36.62-22.303h317.77c18.31 0 33.08 14.673 33.08 32.867v156.71h-16.54v-156.71c0-9.39-7.68-16.433-16.54-16.433v74.538l-8.27 57.518 8.27 49.301-8.27 115.62h-20.67v-98.602l-9.45-11.738-3.54 28.759-20.09 82.168h-20.67l10.63-82.755h-1.18l7.68-63.387-101 21.716h-83.88l15.95 123.84h-20.67l-25.99-112.1-15.36 29.346-8.86 82.755h-20.67v-123.84l-118.13 123.84h-17.129c-7.679 0-13.585-5.869-13.585-13.499v-79.234l-23.036-22.889 51.387 0.587z",
    fill: "#020203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m943.77 380.54 12.147-23.552c0.934-1.805 2.803-2.983 4.828-2.983h41.891c2.41 0 4.36 1.963 4.36 4.396v20.961h-2.18v-20.961c0-1.256-1.01-2.198-2.18-2.198v9.97l-1.09 7.694 1.09 6.594-1.09 15.465h-2.726v-13.188l-1.246-1.57-0.467 3.846-2.647 10.991h-2.725l1.401-11.069h-0.156l1.013-8.479-13.315 2.905h-11.057l2.102 16.564h-2.725l-3.426-14.994-2.024 3.925-1.168 11.069h-2.725v-16.564l-15.573 16.564h-2.258c-1.013 0-1.791-0.785-1.791-1.805v-10.598l-3.037-3.062 6.774 0.079z",
    fill: "#020203"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(610.63 708.9) rotate(89.954) scale(886.63 1270.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8C23",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB978",
    offset: 0.0001
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BFFC4",
    offset: 0.95833
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 599,
    x2: 599,
    y1: 211.94,
    y2: 782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EBB2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004029",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 596.5,
    x2: 596.5,
    y1: 220.5,
    y2: 834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EBB2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006943",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1194,
    height: 834,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "translate(869 347)",
    width: 60,
    height: 35,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "translate(68 437)",
    width: 227,
    height: 135,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginDialogBackground);
export default __webpack_public_path__ + "static/media/LoginDialogBackground.31ff31b85509f6a0def99128a4d7865a.svg";
export { ForwardRef as ReactComponent };